<div class="static-desktop-heading">
  {{ 'about.aboutUs' | translate }}
</div>

<div class="desktop-aligment">
  <div class="desktop-image-container desktop-image-container--about"></div>

  <div class="desktop-column">
    <div class="static-heading">
      {{ 'about.aboutBWM' | translate }}
    </div>

    <div class="static-text" [innerHTML]="'about.goals' | translate | htmlFormat"></div>

    <div class="phone-image-container">
      <img src="/assets/images/static-pages/about-phone-bg.jpg" alt="about banner">
    </div>

    <div class="static-heading-values mt-4">
      {{ 'about.visionsAndValues' | translate }}
    </div>

    <div class="static-text" [innerHTML]="'about.visionsText1' | translate | htmlFormat"></div>
    <div class="static-text" [innerHTML]="'about.visionsText2' | translate | htmlFormat"></div>
    <div class="static-text" [innerHTML]="'about.visionsText3' | translate | htmlFormat"></div>
  </div>
</div>

<libero-static-page-footer></libero-static-page-footer>
